export default __webpack_public_path__ + "static/media/clipboardIcon.9c6d2ada.svg";